// Birthday Marketing tab (MingZe only): auto WhatsApp birthday message X days before.
import React from "react";
import { Alert, Badge, Button, Col, FormGroup, Input, Label, Nav, NavItem, NavLink, Row, Spinner, Table } from "reactstrap";
import { CampaignHistory, CampaignProgress, MessageComposer, PageShell, WhatsappInstances, WhatsappSafetyTips } from "./memberComponents.jsx";
import { WhatsappPreview } from "./BlastWhatsapp.jsx";
import { formatPhone, isOwner, memberPost } from "./memberApi.js";

class BirthdayMarketing extends React.Component {
  state = {
    tab: 'settings', loading: true, settings: null, upcoming: [], instances: [], saving: false, notice: null,
    running: false, testto: '', testing: false, testresult: null, progressId: null,
  };

  componentDidMount() { if (isOwner()) this.load(); }

  load = () => {
    memberPost('birthday-get').then(json => {
      if (json.success == 1) this.setState({ loading: false, settings: json.settings, upcoming: json.upcoming });
      else this.setState({ loading: false, notice: { color: 'danger', text: json.message } });
    });
  };

  set = (key, value) => this.setState({ settings: Object.assign({}, this.state.settings, { [key]: value }) });

  save = () => {
    const st = this.state.settings;
    this.setState({ saving: true, notice: null });
    memberPost('birthday-save', {
      enabled: st.enabled, message: st.message, imageurl: st.imageurl, daysbefore: st.daysbefore, sendtime: st.sendtime, instance: st.instance, interval: st.interval,
    }).then(json => {
      this.setState({ saving: false, notice: json.success == 1 ? { color: 'success', text: 'Settings saved' } : { color: 'danger', text: json.message } });
      if (json.success == 1) this.load();
    });
  };

  runNow = () => {
    if (!window.confirm("Send today's birthday messages now (members whose birthday is " + this.state.settings.daysbefore + " day(s) away)? Members already sent this year are skipped.")) return;
    this.setState({ running: true, notice: null });
    memberPost('birthday-runnow').then(json => {
      this.setState({ running: false, notice: { color: json.success == 1 ? 'info' : 'danger', text: json.message } });
    });
  };

  test = () => {
    const st = this.state.settings;
    if (!this.state.testto.trim() || !st.instance) return;
    this.setState({ testing: true, testresult: null });
    memberPost('test-send', { channel: 'whatsapp', to: this.state.testto.trim(), instancename: st.instance, content: st.message, imageurl: st.imageurl })
      .then(json => this.setState({ testing: false, testresult: json }));
  };

  renderSettings() {
    const st = this.state.settings;
    const connected = this.state.instances.filter(i => i.state === 'open' || i.instancename === st.instance);
    const chosen = this.state.instances.find(i => i.instancename === st.instance);
    return (
      <>
        <WhatsappSafetyTips />
        <Row>
          <Col lg="7">
            <div className="d-flex align-items-center mb-3" style={{ gap: 12 }}>
              <label className="custom-toggle mb-0">
                <input type="checkbox" checked={st.enabled == '1'} onChange={e => this.set('enabled', e.target.checked ? '1' : '0')} />
                <span className="custom-toggle-slider rounded-circle" />
              </label>
              <strong>{st.enabled == '1' ? 'Auto birthday message is ON' : 'Auto birthday message is OFF'}</strong>
            </div>
            {chosen && chosen.state !== 'open' ? <Alert color="warning" className="py-2">The chosen WhatsApp is disconnected. Scan its QR code in WhatsApp Instances.</Alert> : null}
            <Row>
              <Col md="4"><FormGroup><Label className="form-control-label">Send how many days before birthday</Label>
                <Input type="number" min="0" max="30" value={st.daysbefore} onChange={e => this.set('daysbefore', e.target.value)} />
                <small className="text-muted">0 = on the birthday itself</small></FormGroup></Col>
              <Col md="4"><FormGroup><Label className="form-control-label">Send time (daily)</Label>
                <Input type="time" value={st.sendtime} onChange={e => this.set('sendtime', e.target.value)} /></FormGroup></Col>
              <Col md="4"><FormGroup><Label className="form-control-label">Interval (seconds)</Label>
                <Input type="number" min="5" value={st.interval} onChange={e => this.set('interval', e.target.value)} />
                <small className="text-muted">Recommended 15–30s</small></FormGroup></Col>
            </Row>
            <FormGroup><Label className="form-control-label">Send from WhatsApp</Label>
              <Input type="select" value={st.instance} onChange={e => this.set('instance', e.target.value)}>
                <option value="">-- choose --</option>
                {connected.map(i => <option key={i.instancename} value={i.instancename}>{i.displayname}{i.number ? ' (' + formatPhone(i.number) + ')' : ''}</option>)}
              </Input></FormGroup>
            <FormGroup><Label className="form-control-label">Birthday message</Label>
              <MessageComposer whatsapp value={st.message} onChange={v => this.set('message', v)} imageurl={st.imageurl} onImageChange={v => this.set('imageurl', v)} /></FormGroup>

            {this.state.notice ? <Alert color={this.state.notice.color} className="py-2">{this.state.notice.text}</Alert> : null}
            <div className="d-flex flex-wrap" style={{ gap: 8 }}>
              <Button color="primary" onClick={this.save} disabled={this.state.saving}>{this.state.saving ? <Spinner size="sm" /> : 'Save settings'}</Button>
              <Button color="secondary" onClick={this.runNow} disabled={this.state.running}>{this.state.running ? <Spinner size="sm" /> : "Send today's birthdays now"}</Button>
            </div>
            <small className="text-muted d-block mt-2">
              Runs automatically every day at the send time{st.lastrun ? ' · last run ' + st.lastrun.split('-').reverse().join('/') : ''}. Each member receives at most one birthday message per year.
            </small>
          </Col>
          <Col lg="5">
            <h4>Preview</h4>
            <WhatsappPreview text={st.message} imageurl={st.imageurl} />
            <FormGroup className="mt-3"><Label className="form-control-label">Send a test to</Label>
              <div className="d-flex" style={{ gap: 8 }}>
                <Input placeholder="0123456789" value={this.state.testto} onChange={e => this.setState({ testto: e.target.value })} />
                <Button color="secondary" onClick={this.test} disabled={this.state.testing || !st.instance}>{this.state.testing ? <Spinner size="sm" /> : 'Test'}</Button>
              </div></FormGroup>
            {this.state.testresult ? <Alert color={this.state.testresult.success == 1 ? 'success' : 'danger'} className="py-2">{this.state.testresult.success == 1 ? 'Test message sent' : this.state.testresult.message}</Alert> : null}
          </Col>
        </Row>

        <h4 className="mt-4">Upcoming birthdays (next 31 days)</h4>
        <Table size="sm" responsive>
          <thead className="thead-light"><tr><th>In</th><th>Member ID</th><th>Name</th><th>Phone</th><th>Birthday</th><th>WhatsApp</th></tr></thead>
          <tbody>
            {this.state.upcoming.length === 0 ? <tr><td colSpan="6" className="text-center text-muted py-3">No birthdays in the next 31 days</td></tr> :
              this.state.upcoming.map(m => (
                <tr key={m.memberid}>
                  <td>{m.daysaway == 0 ? <Badge color="success">Today 🎂</Badge> : m.daysaway + ' day(s)'}</td>
                  <td>{m.memberid}</td><td>{m.name}</td><td>{formatPhone(m.phone)}</td>
                  <td>{m.birthday.slice(5).split('-').reverse().join('/')}</td>
                  <td>{m.whatsappconsent == 1 ? '✅' : '❌ opted out'}</td>
                </tr>
              ))}
          </tbody>
        </Table>
      </>
    );
  }

  render() {
    const s = this.state;
    return (
      <PageShell title="Birthday Marketing" ownerOnly>
        <Nav tabs className="mb-4">
          {[['settings', 'Birthday Message'], ['instances', 'WhatsApp Instances'], ['history', 'Sent History']].map(([key, label]) => (
            <NavItem key={key}><NavLink href="#" active={s.tab === key} onClick={e => { e.preventDefault(); this.setState({ tab: key }); }}>{label}</NavLink></NavItem>
          ))}
        </Nav>
        <div style={{ display: s.tab === 'instances' ? 'block' : 'none' }}>
          <WhatsappInstances onLoad={instances => this.setState({ instances })} />
        </div>
        {s.tab === 'settings' ? (s.loading || !s.settings ? (s.notice ? <Alert color={s.notice.color}>{s.notice.text}</Alert> : <Spinner />) : this.renderSettings()) : null}
        {s.tab === 'history' ? <CampaignHistory channel="whatsapp" campaigntype="birthday" onResume={id => this.setState({ progressId: id })} /> : null}
        {s.progressId ? <CampaignProgress campaignid={s.progressId} onClose={() => this.setState({ progressId: null })} /> : null}
      </PageShell>
    );
  }
}

export default BirthdayMarketing;
